export const NONE = "-- None --";
